/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/

import moment from 'moment-timezone';



const validateMonthAndDay = (value) => {
  const formatIsValid = /^[0-9]{2}\/[0-9]{2}$/.test(value);
  const date = moment(value, 'MM/DD');
  const dateIsvalid = date.isValid();

  if (formatIsValid && dateIsvalid) {
    return true;
  }

  return 'Invalid date (MM/DD).';
};



export default validateMonthAndDay;
